import React, {Component} from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import Analytics from '@cred/react-analytics'

const withAnalyticsOnTabClick = WrappedComponent =>
  class extends Component {
    static propTypes = {
      onClick: PropTypes.func,
      href: PropTypes.string,
      children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.element
      ])
    }

    static defaultProps = {onClick: () => {}}

    static displayName = `${WrappedComponent.displayName}WithAnalyticsOnTabClick`

    constructor(props) {
      super(props)

      this.analytics = new Analytics(props.analytics)
    }

    componentDidUpdate(prevProps) {
      if (
        prevProps.analytics &&
        !isEqual(prevProps.analytics.contexts, this.props.analytics.contexts)
      ) {
        this.analytics = new Analytics(this.props.analytics)
      }
    }

    onTabClick = index => {
      const {children} = this.props

      this.analytics.event({text: children[index].props.title})
    }

    render() {
      const {onTabTitleClick, ...props} = this.props

      return <WrappedComponent onTabClick={this.onTabClick} {...props}/>
    }
  }

export default withAnalyticsOnTabClick
